import { useEffect, useRef } from 'react';

/**
 *  This hook is used to get a ref to a callback function that will be updated when the callback changes.
 */
export const useCallbackRef = <T extends (...args: any[]) => any>(
  callback: T | null | undefined
) => {
  const callbackRef = useRef<T | null | undefined>(null);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  return callbackRef;
};
